module.exports = __webpack_public_path__ + "media/applicants/icon-add-avatar-0fcaac68.png";